/**
 * Split-screen layout for VIVA HUB auth pages (login, forgot password, etc.)
 */

import React from 'react'
import VersionBadge from '../VersionBadge'
import HubLoginIllustration from './HubLoginIllustration'
import HubThemeToggle from './HubThemeToggle'

export const HUB_AUTH_INPUT_CLASS =
  'block w-full rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-primary-darkGreen focus:outline-none focus:ring-2 focus:ring-primary-darkGreen/20'

export const HUB_AUTH_BUTTON_CLASS =
  'w-full rounded-lg px-4 py-2.5 text-base font-semibold text-white shadow-sm transition-colors hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-primary-darkGreen focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60'

export const HUB_AUTH_BUTTON_STYLE = { backgroundColor: 'var(--color-primary-darkGreen)' }

export default function HubAuthLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      <div className="absolute top-4 right-4 z-10 lg:right-auto lg:left-4">
        <HubThemeToggle variant="button" />
      </div>

      <div className="flex min-h-screen w-full items-center justify-center bg-white px-6 py-10 sm:px-10 lg:w-2/5 lg:shrink-0 lg:px-12 xl:px-16">
        <div className="w-full max-w-sm">
          <h1
            className="mb-8 text-center text-2xl font-bold tracking-tight sm:text-3xl"
            style={{ color: 'var(--color-primary-darkGreen)' }}
          >
            VIVA HUB
          </h1>

          {children}

          <p className="mt-8 text-center">
            <VersionBadge className="text-gray-400" />
          </p>
        </div>
      </div>

      <div
        className="relative hidden min-h-screen w-full lg:flex lg:w-3/5 lg:shrink-0"
        style={{ backgroundColor: 'var(--color-primary-darkGreen)' }}
      >
        <HubLoginIllustration />
      </div>
    </div>
  )
}
